import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';

class RevealSlideDown extends Component {
  render() {
    const { delay, isInView } = this.props;

    const returnDelaySetting = () => {
      return typeof delay !== 'undefined' ? delay : 300;
    };

    const animationConfig = {
      delay: returnDelaySetting(),
      duration: 900,
      easing: easings.easeCubicOut,
    };

    const renderChildren = animation => {
      const children = React.Children.map(this.props.children, child => {
        return React.cloneElement(child, {
          animation,
          isInView,
        });
      });
      return children;
    };

    return (
      <Spring
        from={{ opacity: 0, transform: 'translateY(120px)' }}
        to={{
          opacity: isInView ? 1 : 0,
          transform: isInView ? 'translateY(0)' : 'translateY(120px)',
        }}
        config={animationConfig}
      >
        {animation => renderChildren(animation)}
      </Spring>
    );
  }
}

RevealSlideDown.propTypes = {
  delay: PropTypes.number,
  isInView: PropTypes.bool,
};

export default RevealSlideDown;



// WEBPACK FOOTER //
// ./src/components/animations/reveal-slide-down/index.js